/* ================================================= */
/* Función para mostrar alerta al agregar al carrito */
/* ================================================= */
function launch_toast() {
	var x = document.getElementById("toast")
	x.className = "show";
	setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
}

$(document).ready(function() {
	/* =============================================== */
	/* Mostrar alerta al agregar al carrito */
	/* =============================================== */
	//$(".quick-add, #AddToCart").click(function() {
	$(document).on('click', ".quick-add, #AddToCart", function(){
		setTimeout(function() { 
			launch_toast();
		}, 100);
		setTimeout(function() { 
			$(".qty-input").val("1");
		}, 500);
	});

	/* =============================================== */
	/* Incrementar / Decrementar cantidad */
	/* =============================================== */

	//$('.minus').click(function () {
	$(document).on('click', ".minus", function(){
		var $input = $(this).parent().find('input');
		var count = parseInt($input.val()) - 1;
		count = count < 1 ? 1 : count;
		$input.val(count);
		$input.change();
		return false;
    });
    
    //$('.plus').click(function () {
    $(document).on('click', ".plus", function(){
		var $input = $(this).parent().find('input');
		$input.val(parseInt($input.val()) + 1);
		$input.change();
		return false;
    });

    /* =============================================== */
	/* Menu Hover */
	/* =============================================== */




if (screen.width < 992) {
   
   	$(".productos").click(function(){
	  $(".dropdown-menu").addClass('show');
	});

}else{
	    $('.parent').hover(
		function() {
			$( this ).find('.dropdown-menu').addClass('show');
		}, function() {
			$( this ).find('.dropdown-menu').removeClass('show');
		}
	);

}


    /* =============================================== */
	/* Fixed navbar on scroll */
	/* =============================================== */

	$(window).scroll(function() {    
	    var scroll = $(window).scrollTop();

	     //>=, not <=
	    if (scroll >= 50) {
	        //clearHeader, not clearheader - caps H
	        $(".top-header__container, .top-header").hide();
	    }

	    if (scroll < 50) {
	        $(".top-header__container, .top-header").show();
	    }
	}); //missing );

	/* =============================================== */
	/* Menu Mobile */
	/* =============================================== */
	$(".open-menu, .close-menu").click(function() {
		$(".menu-mobile__container").toggleClass("show");
		$(".open-menu, .close-menu").toggleClass("hide");
	});

		$(".close-menu").click(function() {
		$(".dropdown-menu-mobile").removeClass("show");
	});

	$(document).on('click', ".tienda", function(){
		$(".dropdown-menu-mobile").addClass("show");
	});

	$(document).on('click', "#previous-menu", function(){
		setTimeout(function() {
			$(".dropdown-menu-mobile").toggleClass("show");
		}, 200)
	});

	//*******************************************************************************
	// Increment quantity cart
	//*******************************************************************************

	$(document).on("click touchstart", ".add-qty-js", function () {
	    var producto_id = $(this).data('variant');

	    if ($(".order-discount-"+producto_id).length > 0){
		    var d_qty_value = $(".quantity-"+producto_id).val();
		    var d_qty = parseInt(d_qty_value);
		    var d_price = $(".price-discount-"+producto_id).text();
		    d_price = d_price.replace('$', '');
		    d_price = d_price.replace('.', '');
		    d_price = d_price.replace(',', '');
		    d_price = parseFloat(d_price);
		    var d_totalPrice = (d_price * d_qty);
	    	$(".order-discount-"+producto_id).text(Shopify.formatMoney(d_totalPrice));
	    }

	    var qty_value = $(".quantity-"+producto_id).val();
	    var qty = parseInt(qty_value);
	    var price = $(".price-"+producto_id).text();
	    price = price.replace('$', '');
	    price = price.replace('.', '');
	    price = price.replace(',', '');
	    price = parseFloat(price);
	    var totalPrice = (price * qty);
	    $(".price-final-"+producto_id).text(Shopify.formatMoney(totalPrice));
	    //console.log($(".order-discount-"+producto_id).length);

	    var input_class = '.quantity-'+producto_id;
	    jQuery.post('/cart/change.js', { quantity: qty, id: producto_id }, null, "json")
	    .done(function(){
	      jQuery.getJSON('/cart.js', function(cart) {
	         $('.cart__subtotal-price').html(Shopify.formatMoney(cart.total_price));
	      });
	      $(input_class).val(qty);
	    });
	});

	$(document).on("click touchstart", ".remove-qty-js", function () {
	    var producto_id = $(this).data('variant');

	    if ($(".order-discount-"+producto_id).length > 0){
		    var d_qty_value = $(".quantity-"+producto_id).val();
		    var d_qty = parseInt(d_qty_value);
		    var d_price = $(".price-discount-"+producto_id).text();
		    d_price = d_price.replace('$', '');
		    d_price = d_price.replace('.', '');
		    d_price = d_price.replace(',', '');
		    d_price = parseFloat(d_price);
		    var d_totalPrice = (d_price * d_qty);
	    	$(".order-discount-"+producto_id).text(Shopify.formatMoney(d_totalPrice));
	    }

	    var qty_value = $(".quantity-"+producto_id).val();
	    var qty = parseInt(qty_value);
	    var price = $(".price-"+producto_id).text();
	    price = price.replace('$', '');
	    price = price.replace('.', '');
	    price = price.replace(',', '');
	    price = parseFloat(price);
	    var totalPrice = (price * qty);
	    $(".price-final-"+producto_id).text(Shopify.formatMoney(totalPrice));
	    

	    var input_class = '.quantity-'+producto_id;
	    jQuery.post('/cart/change.js', { quantity: qty, id: producto_id }, null, "json")
	    .done(function(){
	      jQuery.getJSON('/cart.js', function(cart) {
	         $('.cart__subtotal-price').html(Shopify.formatMoney(cart.total_price));
	      });

	      if(qty == 0) {
	        location.reload(true);
	      } else {
	        $(input_class).val(qty);
	      }
	    });
	});

	/*$('a[href="#"]').click(function(e) {
	    e.preventDefault ? e.preventDefault() : e.returnValue = false;
	});*/

});